import React, { useEffect, useState } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { supabase } from "../lib/supabase";

const ProtectedRoute = ({ children, requiresUsername = true }) => {
  const { user, loading } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const location = useLocation();


  useEffect(() => {
    const fetchUserProfile = async () => {
      if (user && supabase) { 
        try {
          const { data, error } = await supabase
            .from('profiles')
            .select('username')
            .eq('id', user.id)
            .maybeSingle();

          if (error) throw error;
          setUserProfile(data);
        } catch (error) {
          console.error('Error fetching user profile:', error);
        }
      }
      setProfileLoading(false);
    };

    if (user && !loading && supabase) { 
      fetchUserProfile();
    } else if (!loading) {
      setProfileLoading(false);
    }
  }, [user, loading, supabase]);

  if (loading || profileLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    requiresUsername &&
    userProfile &&
    userProfile.username &&
    location.pathname === '/set-username'
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // If children are provided, render them, else render <Outlet /> for nested routes
  return children ? children : <Outlet />;
};

export default ProtectedRoute;